import { useEffect, useState } from 'react';

import ByCheckBrowser from '@/components/ByCheckBrowser';
import { useI18nContext } from '@/i18n/I18n';
import * as UserApi from '@/services/user';
import { setLang } from '@/utils/common/storage';
import { WHITE_HOST } from '@/utils/constants/common';
import { getRedirectInfo, showRedirectModal } from '@/utils/redirectInfo';
import { SubAccountLoginRedirectErrorTrack } from '@/utils/trace-list/subAccount';
import { jumpMePage } from '@/utils/ua';

import ErrorLimitModal from './ErrorLimitModal';
import { ErrorLoginModal } from './ErrorLoginModal';
import LoginForm from './LoginForm';

let permission_v2_flag = false;

const SubAccountLogin = () => {
  const [_, lang] = useI18nContext();

  const [showErrorTip, setShowErrorTip] = useState(false);
  const [errorCode, setErrorCode] = useState<any>();

  const [showErrorLimitModal, setShowErrorLimitModal] = useState(false);

  const hideErrorModal = () => {
    setShowErrorTip(false);
  };

  // 检查是否是老用户访问的nl语言
  // 是：重定向到用户设置的通知语言或者 en-US
  // 否：保持当前访问语言
  const setIpInfoFunc = () => {
    if (permission_v2_flag) return;
    permission_v2_flag = true;
    return UserApi.registerPermisson()
      .then((res) => {
        return res;
      })
      .finally(() => {
        permission_v2_flag = false;
      });
  };

  const getTime = (date: string) =>
    date ? new Date(date).getTime() : new Date('2023-07-26 12:00:00').getTime();
  const checkOldNlUser = async (
    createTime: string,
    noticeLang: string,
    isLogin = false,
  ) => {
    const nlLang = lang === 'nl-NL';
    const _createTime = isLogin ? +createTime : getTime(createTime);
    const earlierUser = createTime
      ? _createTime - getTime('2023-07-26 12:00:00') < 0
      : false;
    if (nlLang && earlierUser) {
      try {
        const res = await setIpInfoFunc();
        if (res.code === 'NL') {
          const newLang = noticeLang !== 'nl-NL' ? noticeLang : 'en';
          setLang(newLang);
          !isLogin && window.location.reload();
          return newLang;
        }
        return lang;
      } catch (error) {
        return lang;
      }
    }
    return lang;
  };

  // 登录成功回调
  const loginSuccess = async (res: any) => {
    const { currentSite } = res;
    // 返回结构不确定
    const { country, create_time, registration_origin_time, userInfoResult } =
      res?.result || res;

    const search = new URLSearchParams(location.search);

    const fromOAuth = search.get('from') === 'oauth';

    if (fromOAuth) {
      window.location.href = `/${lang}/oauth-authorized?${search}`;
      return;
    }

    const redirectUrl = search.get('redirect_url');
    if (redirectUrl) {
      try {
        const url = new URL(redirectUrl);
        if (WHITE_HOST.some((host) => url?.host?.indexOf?.(host) > -1)) {
          window.location.href = redirectUrl;
          return;
        } else {
          SubAccountLoginRedirectErrorTrack(search);
        }
      } catch (error) {
        /* empty */
      }
    }
    const { lang: _lang } = userInfoResult || {};
    const newLang = await checkOldNlUser(create_time, _lang || 'en', true);
    const { isNeedJump, jumpSite } = getRedirectInfo({
      kycCountry: country,
      currentSite: currentSite,
      registerTime: create_time,
      registrationOriginTime: registration_origin_time,
    });
    if (isNeedJump) {
      showRedirectModal({
        currentSite,
        jumpSite,
        redirectUrl: '',
        onClose: () => {
          jumpMePage(newLang);
        },
      });
      return;
    }
    jumpMePage(newLang);
  };

  useEffect(() => {
    return () => {
      document.documentElement.removeAttribute('hide-security-find-entry');
    };
  }, []);

  return (
    <>
      <ByCheckBrowser></ByCheckBrowser>
      <LoginForm
        onForbiddenLogin={(errorCode) => {
          setErrorCode(errorCode);
          setShowErrorTip(true);
        }}
        onErrorLimit={() => {
          setShowErrorLimitModal(true);
        }}
        loginSuccess={loginSuccess}
      />
      {/* 错误次数太多，子账号封禁提示 */}
      {showErrorLimitModal && (
        <ErrorLimitModal
          onClose={() => {
            setShowErrorLimitModal(false);
          }}
        />
      )}
      {/* 非当前站点儿用户登录子账号错误提示 */}
      {showErrorTip && (
        <ErrorLoginModal
          errorCode={errorCode}
          onClose={hideErrorModal}
          showErrorTip={showErrorTip}
        />
      )}
    </>
  );
};
export default SubAccountLogin;
